// angular dependencies
import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// third-party dependencies
import { RouterReducerState } from '@ngrx/router-store';

// fantaz dependencies
import { AuthShellComponent } from '@fantaz/auth/features/shell';
import { CoreModule } from '@fantaz/core';
import { ProfileDataAccessModule } from '@fantaz/profile/data-access';
import { PromoCodeDataAccessModule } from '@fantaz/promo-code/data-access';
import { TermsAndConditionsFeaturesShellModule } from '@fantaz/terms-and-conditions/features/shell';
import { UserGameProfileFeaturesShellModule } from '@fantaz/user-game-profile/features/shell';
import { UserVerificationFeaturesShellModule } from '@fantaz/user-verification/features/shell';

import { AppComponent } from './app.component';

export interface AppState {
  router: RouterReducerState<any>;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    TermsAndConditionsFeaturesShellModule,
    ProfileDataAccessModule,
    PromoCodeDataAccessModule,
    UserGameProfileFeaturesShellModule,
    UserVerificationFeaturesShellModule,
    RouterModule.forRoot([
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
          import('@fantaz/home/features/shell').then(
            (module) => module.HomeFeaturesShellModule,
          ),
        canMatch: [
          () => {
            const ls = localStorage.getItem('prefs');
            const qp = new URLSearchParams(window.location.search);
            let playPage = '/tournaments';

            // if sh (show home) is set, not redirect to the play page
            if (qp.has('sh') || !ls) {
              return true;
            }

            try {
              const prefs = JSON.parse(ls) || {};

              if (prefs?.playPage) {
                playPage = prefs.playPage;
              }
            } catch (e) {}

            window.location.href = playPage;

            return true;
          },
        ],
      },
      {
        path: 'promo/:promocode',
        pathMatch: 'full',
        loadChildren: () =>
          import('@fantaz/home/features/shell').then(
            (module) => module.HomeFeaturesShellModule,
          ),
      },
      {
        path: 'support',
        redirectTo: 'help',
      },
      {
        path: 'help',
        loadChildren: () =>
          import('@fantaz/home/features/shell').then(
            (module) => module.HomeFeaturesShellModule,
          ),
        data: {
          openSupport: true,
        },
      },
      {
        path: 'mail',
        loadChildren: () =>
          import('@fantaz/mailing/features/shell').then(
            (module) => module.MailingFeaturesShellModule,
          ),
      },
      {
        path: 'join',
        component: AuthShellComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@fantaz/auth/join').then((m) => m.FzJoinComponent),
          },
          {
            path: ':username',
            loadComponent: () =>
              import('@fantaz/auth/join').then((m) => m.FzJoinComponent),
          },
        ],
      },
      {
        path: '**',
        redirectTo: '/',
      },
    ]),
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
